import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from './styles/tokens';

// Page-level heading for single-page (no-steps) v2 funnels — where there's no
// ProgressBar to anchor the top of the page and establish what the page is.
// Sits inside the same 540px column as FormLayout.
export const PageHeading = styled.div`
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  padding: 4px 10px 14px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 4px 7px 14px;
  }
`;

export const PageHeadingTitle = styled.h1`
  margin: 0 0 4px;
  font-family: ${v2FontFamily};
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: ${v2Colors.primary};

  @media (max-width: ${v2Breakpoints.tablet}) {
    font-size: 21px;
  }
`;

export const PageHeadingSubtitle = styled.p`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 14px;
  line-height: 1.4;
  color: ${v2Colors.textMuted};
`;
